import React, { useState, useMemo } from 'react';
import Button from './Button';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface DocumentSubtypeButtonsProps {
  subtypes: string[];
  onSubtypeSelect: (subtype: string) => void;
  selectedSubtypes?: string[];
  maxVisible?: number;
  className?: string;
}

const DocumentSubtypeButtons: React.FC<DocumentSubtypeButtonsProps> = ({
  subtypes,
  onSubtypeSelect,
  selectedSubtypes = [],
  maxVisible = 8,
  className = ""
}) => {
  const [showAll, setShowAll] = useState(false);

  const visibleSubtypes = useMemo(() => {
    if (showAll || subtypes.length <= maxVisible) {
      return subtypes;
    }
    return subtypes.slice(0, maxVisible);
  }, [subtypes, showAll, maxVisible]);

  const hasMore = subtypes.length > maxVisible;

  return (
    <div className={`space-y-3 ${className}`}>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        {visibleSubtypes.map((subtype) => (
          <Button
            key={subtype}
            variant={selectedSubtypes.includes(subtype) ? 'primary' : 'outline'}
            size="sm"
            className="text-xs bg-transparent border-teal-dark hover:bg-teal-dark/5 text-teal-dark focus:ring-teal-light"
            onClick={() => onSubtypeSelect(subtype)}
          >
            {subtype}
          </Button>
        ))}
      </div>
      
      {hasMore && (
        <div className="flex justify-center">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setShowAll(!showAll)}
            className="text-teal-dark hover:bg-teal-dark/5"
          >
            {showAll ? (
              <>
                <ChevronUp className="w-4 h-4 mr-1" />
                Voir moins
              </>
            ) : (
              <>
                <ChevronDown className="w-4 h-4 mr-1" />
                Voir plus ({subtypes.length - maxVisible} autres)
              </>
            )}
          </Button>
        </div>
      )}
    </div>
  );
};

export default DocumentSubtypeButtons;
